function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
import React from "react";
import isKeyboardEventFromInput from "./isKeyboardEventFromInput";
export var EventBus = /*#__PURE__*/ function() {
    "use strict";
    function EventBus() {
        _classCallCheck(this, EventBus);
        this.scope = "app";
        this.prevScope = "app";
        this.events = {
            app: []
        };
        this.debouncers = {};
    }
    var _proto = EventBus.prototype;
    _proto.handleEvent = function handleEvent(event) {
        var _this = this;
        if (!this.events[this.scope]) return;
        if (isKeyboardEventFromInput(event)) return;
        var eventKey = event.key.toLowerCase();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _this1 = this, _loop = function() {
                var item = _step.value;
                if (eventKey === item.key.toLowerCase()) {
                    clearTimeout(_this1.debouncers[eventKey]);
                    _this1.debouncers[eventKey] = setTimeout(function() {
                        item.handler(event);
                        _this.debouncers[eventKey] = undefined;
                    }, 100);
                }
            };
            for(var _iterator = this.events[this.scope][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.handleProxiedEvent = function handleProxiedEvent(event) {
        this.handleEvent(event.detail.originalEvent);
    };
    _proto.bind = function bind(el) {
        el.addEventListener("keydown", this.handleEvent.bind(this));
        el.addEventListener("extension-keydown", this.handleProxiedEvent.bind(this));
    };
    _proto.unbind = function unbind(el) {
        el.removeEventListener("keydown", this.handleEvent);
        el.removeEventListener("extension-keydown", this.handleProxiedEvent);
    };
    _proto.setScope = function setScope(newScope) {
        this.prevScope = this.scope;
        this.scope = newScope;
    };
    _proto.usePrevScope = function usePrevScope() {
        this.scope = this.prevScope;
        this.prevScope = "app";
    };
    // FIXME: don't use push since it may lead to duplicate events
    _proto.register = function register(key, scope, handler) {
        if (!(scope in this.events)) {
            this.events[scope] = [];
        }
        this.events[scope].push({
            key: key,
            handler: handler
        });
    };
    _proto.unregister = function unregister(key, scope) {
        if (!(scope in this.events)) return;
        this.events[scope] = this.events[scope].filter(function(item) {
            return item.key != key;
        });
    };
    return EventBus;
}();
var eventBus = new EventBus();
export default eventBus;
